import request from "../request";

export default {
	login(data) {
		return request.post("/admin/login", data);
	},
	
	//账号-列表
	lists(data) {
		return request.get("/admin/lists", data);
	},
	
	//账号-添加
	add(data) {
		return request.post("/admin/add", data);
	},
	
	//账号-修改
	edit(data) {
		return request.post("/admin/edit", data);
	},
	
	//账号-删除
	delete(data) {
		return request.post("/admin/delete", data);
	},
	
};
